<template>
  <div id="app">
    <div class="fixed_router_header">
      <div id="hd">
        <div id="nav">
          <router-link to="/">
            <span style="font-size: 115%; color: white; text-shadow: 1px 1px 2px rgba(00,00,00,.9);">
              VideoStreamer<span class="gradient" style="text-shadow:-1px 1px 2px blue;"><i><b>Vue</b></i></span>
            </span>
          </router-link> |
          <router-link to="/about">Om</router-link>
        </div>
      </div>
    </div>
    <div style="height: 100%">
      <!-- route outlet -->
      <!-- component matched by the route will render here -->
      <router-view/>
    </div>
  </div>
</template>

<script>
import {globalStore} from './main.js'
import gmapsInit from './gmaps';

export default {
  data() {
    return {
      msg: 'Welcome to the header',
    }
  },
  methods: {
    
  },
  mounted() {
        globalStore.mobileMode = window.innerWidth <= 1024;
        window.onresize = () => {
            this.windowWidth = window.innerWidth;
            globalStore.mobileMode = window.innerWidth <= 1024;
        };

        // If a One Time Token has been provided (using the "ott" URL query parameter)
        // we store that token here in the web browser local storage. This is so that we
        // can fetch it later after the user has logged in or signed up. The One Time
        // Token must be sent in each call to the back-end to provide access to the
        // folders specified in the videostreamer_ott2start_folder_mapping.txt file.
        // By default, a newly signed up user have no privileges assigned to it by auth0.
        // The administrator has to manually add privileges to the new user.
        if(this.$route.query.ott) {
          localStorage.ott = this.$route.query.ott;
        }
        //alert("App mounted. LS ott: " + localStorage.ott);

        /*try {
                  const google = await gmapsInit();
                  console.log("1");
                  const geocoder = new google.maps.Geocoder();
                  console.log("2");
                  //const map = new google.maps.Map(this.$el);
                  const map = new google.maps.Map(document.getElementById("map"),
                  {
                    zoom: 4,
                    center: { lat: -25.344, lng: 131.036 }
                  });
                  console.log("3");

                  geocoder.geocode({ address: 'Austria' }, (results, status) => {
                    if (status !== 'OK' || !results[0]) {
                      throw new Error(status);
                    }

                    map.setCenter(results[0].geometry.location);
                    map.fitBounds(results[0].geometry.viewport);
                  });
                } catch (error) {
                  console.error(error);
                }*/
    },
}
</script>

<style lang="scss">
body, html {
  height: 100%;
  width: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  text-align: left;
  color: #bfccd8;
  height: 100%;

  /*a {
    color: yellow;
  }
  a:hover {
    color: rgba(255, 255, 255, 0.823);
  }*/
}

// This is for customizing the layout of the vue-picture-swipe component.
// It placese its thumbnail image inside a <figure>-tag which we can customize here.
.staffans_picture_swipe {
  figure {
    padding: 5px;
    margin: 5px;
    }
}

.staffans_picture_swipe_mobile {
  figure {
    display: inline-block;
    width: 100%;
    padding: 0px;
    margin: 0px;
    }
}

.userName {
  color: yellow;
  text-decoration: none;
  vertical-align: middle;
}

#nav {
  padding: 3px;
  display: inline-block;

  a {
    font-size: 90%;
    font-weight: bold;
    color: #575081;
    text-decoration: none;

    &.router-link-exact-active {
      color: #f2ff35;
    }
  }

  a:hover {
    color: rgba(255, 255, 255, 0.823);
  }
}


.fixed_router_header {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    left: 0; /* top left corner should start at leftmost spot */
    top: 0; /* top left corner should start at topmost spot */
    width: 100vw; /* take up the full browser width */
    z-index: 200; /* high z index so other content scrolls underneath */
    height: 20px; /* define height for content */
}

#hd {
    width: 100%;
    z-index: 0;
    height: 30px;
    position: relative;
    background: linear-gradient( #000000, #0000ff);
}

.gradient {
	color: yellow;
	font-size: 12pt;
	display: inline;
	padding-left: 2px;
	padding-right: 4px;
	margin-left: 2px;
  background: linear-gradient( #00efef, #000000);
  border-radius: 5px;
}

.subfolder-list {
    float: top;
    padding: 5px;
    //background-color: blue;
}

.sticky_footer {
    position: fixed; /* fixing the position takes it out of html flow - knows
            nothing about where to locate itself except by browser
            coordinates */
    float:right;
    bottom: 0px; /* top left corner should start at topmost spot */
    right: -1px;
    width: 100vw; /* take up the full browser width */
    z-index: -20; /* high z index so other content scrolls underneath */
    height: 100px; /* define height for content */
}
</style>
